module.exports = __webpack_public_path__ + "static/media/panis_20.27d85047.jpg";